import AccessTimeIcon from "@mui/icons-material/AccessTime";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SettingsIcon from "@mui/icons-material/Settings";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Modal,
  Popover,
  Select,
  Skeleton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  handleCurrentCompanyAction,
  handleLogOut,
  resetAllStateAction,
} from "../../redux/actoin";
import BroadCrumb from "./broadCrumb";
const PageTitle = ({ hideTitle = true, broadCrumb = [], title }) => {
  const UserDetail = useSelector((state) => state.UserDetail);
  const { userDetails } = UserDetail;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [newVersion, setNewVersion] = useState(false);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const isMd = useMediaQuery("(min-width:1000px)");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);
  const AppVersion = useSelector((state) => state.AppVersion);
  const { version } = AppVersion;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const userCompany = useSelector((state) => state.userCompany);
  const { companies, loading } = userCompany;
  const handleClose = () => {
    setAnchorEl(null);
  };
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [today, setDate] = useState(new Date());
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const handleLogout = () => {
    dispatch(handleLogOut());
    /*     dispatch(handleThemeToggle("light"));
     */
  };
  useEffect(() => {}, [userInfo]);
  const handleUpdate = () => {
    window.location.reload(true);
    localStorage.setItem("version", version);
  };
  const handleChange = (event) => {
    dispatch(
      handleCurrentCompanyAction(
        companies?.find((item) => item?.guidRecNo === event.target.value)
      )
    );
    dispatch(resetAllStateAction());
  };
  return (
    <Box
      className={`z-50 relative bg-transparent px-4 ${
        isMd ? "h-20" : "h-32"
      } h-20 gap-2  flex-col justify-center`}
      sx={{
        display: "flex",
      }}
    >
      {/*     {!isMd && (
        <IconButton>
          {" "}
          <MenuIcon
            onClick={() => dispatch(handleModalAction({ login: true }))}
          />
        </IconButton>
      )} */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
        className="w-full"
      >
        {hideTitle && (
          <div
            className="overflow-x-auto overflow-y-hidden pl-3 noScroll max-w-[350px]
      p-2 "
          >
            <div className="w-full min-w-max">
              <BroadCrumb
                current={title}
                links={[
                  {
                    title: "داشبورد",
                    path: "/",
                  },
                  ...broadCrumb,
                ]}
              />
            </div>
          </div>
        )}
        <div className="flex items-center gap-2">
          {isMd && (
            <>
              <Box
                sx={{
                  background: (theme) =>
                    theme.palette.mode === "light" ? "#f0f2f5" : "#1a2935",
                }}
                className="flex mx-5 gap-2 items-center cursor-pointer relative rounded-[10px] py-3 px-7"
              >
                {loading ? (
                  <Skeleton
                    width={"100%"}
                    height={50}
                    variant="rounded"
                    animation="wave"
                  />
                ) : (
                  <FormControl
                    sx={{
                      ".MuiInputBase-root": {
                        ":after": {
                          border: "0px !important",
                        },
                        ":before": {
                          border: "0px !important",
                        },
                        /*   width:"200px !important" */
                      },
                    }}
                  >
                    <Select
                      labelId="demo-simple-select-readonly-label"
                      id="demo-simple-select-readonly"
                      value={company?.guidRecNo}
                      variant="standard"
                      fullWidth
                      onChange={handleChange}
                      inputProps={{ readOnly: companies?.length < 2 }}
                    >
                      {companies?.map((item, index) => (
                        <MenuItem value={item?.guidRecNo} key={item?.guidRecNo}>
                          {item?.chName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {version !== localStorage.getItem("version") ? (
                  <div
                    onClick={() => setNewVersion(true)}
                    className="absolute top-1/2 -translate-y-1/2 left-[10px]"
                  >
                    <svg height="12" width="12" className="blinking">
                      <circle cx="6" cy="6" r="6" fill="#ef4056" />
                    </svg>
                  </div>
                ) : (
                  <></>
                )}
              </Box>
              <Box
                sx={{
                  background: (theme) =>
                    theme.palette.mode === "light" ? "#f0f2f5" : "#1a2935",
                }}
                className="flex mx-5 gap-2 items-center rounded-[10px] py-3 px-7"
              >
                <AccessTimeIcon sx={{ fontSize: "1rem !important" }} />
                <span className="text-xs">امروز :‌ </span>
                <span className="text-xs">
                  {moment(new Date(), "YYYY-MM-DD HH:mm:ss")
                    .locale("fa")
                    .format("dddd")}
                </span>
                <span className="text-xs">
                  {new Intl.DateTimeFormat("fa-IR", {
                    month: "short",
                    day: "numeric",
                  }).format(new Date())}{" "}
                  ,
                </span>
                <span className="text-xs">
                  ساعت {today.getMinutes()}:‌ {today.getHours()}{" "}
                </span>
              </Box>
            </>
          )}{" "}
          <button
            aria-describedby={id}
            onClick={handleClick}
            className="flex gap-2  items-center border px-2 py-2 rounded-[10px]"
          >
            {" "}
            <div className="flex items-center justify-center md:w-[30px] md:h-[30px] w-[25px] h-[25px] rounded-full ">
              {userDetails?.chPortraitBase64 ? (
                <>
                  <img
                    src={userDetails?.chPortraitBase64}
                    className=" rounded-full"
                    alt=""
                  />
                </>
              ) : (
                <>
                  <PersonOutlineIcon
                    sx={{
                      color: "#cfcfcf",
                      fontSize: { md: "25px", xs: "15px" },
                    }}
                  />
                </>
              )}
            </div>
            <div className="flex   gap-2 ">
              {/*  <Typography
            sx={{
              fontSize: {
                md: "0.9rem !important",
                xs: "1rem !important",
              },
              color: (theme) =>
                theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
              fontWeight: 900,
            }}
          >
            {userDetails.chUserTypeTitle}
          </Typography> */}
              <div className="flex items-center gap-2 cursor-pointer">
                {isMd && (
                  <Typography
                    sx={{
                      fontSize: {
                        md: "0.85rem !important",
                        xs: "1rem !important",
                      },
                    }}
                  >
                    {userDetails?.guidRecNo ? (
                      <>
                        {userDetails?.chFirstName} {userDetails?.chLastName}
                      </>
                    ) : (
                      <>
                        <Skeleton variant="rounded" width={100} height={20} />
                      </>
                    )}
                  </Typography>
                )}

                <KeyboardArrowDownIcon
                  sx={{
                    fontSize: "0.8rem !important",
                    color: "#fff !important",
                  }}
                />
              </div>
            </div>
          </button>
        </div>
      </Box>
      {!isMd ? (
        <>
          {" "}
          <Box
            sx={{
              background: (theme) =>
                theme.palette.mode === "light" ? "#f0f2f5" : "#1a2935",
            }}
            className="flex mx-1 gap-2 items-center relative rounded-[10px] py-3 px-2"
          >
            {loading ? (
              <Skeleton
                width={"100%"}
                height={50}
                variant="rounded"
                animation="wave"
              />
            ) : (
              <FormControl
                sx={{
                  ".MuiInputBase-root": {
                    ":after": {
                      border: "0px !important",
                    },
                    ":before": {
                      border: "0px !important",
                    },
                    /*   width:"200px !important" */
                  },
                }}
              >
                <Select
                  labelId="demo-simple-select-readonly-label"
                  id="demo-simple-select-readonly"
                  value={company?.guidRecNo}
                  variant="standard"
                  fullWidth
                  onChange={handleChange}
                  inputProps={{ readOnly: companies?.length < 2 }}
                >
                  {companies?.map((item, index) => (
                    <MenuItem value={item?.guidRecNo} key={item?.guidRecNo}>
                      {item?.chName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
            {version !== localStorage.getItem("version") ? (
              <div
                onClick={() => setNewVersion(true)}
                className="absolute top-1/2 -translate-y-1/2 left-[10px]"
              >
                <svg height="12" width="12" className="blinking">
                  <circle cx="6" cy="6" r="6" fill="#ef4056" />
                </svg>
              </div>
            ) : (
              <></>
            )}
          </Box>
        </>
      ) : (
        <></>
      )}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div className={`flex flex-col py-4 px-4 gap-3 theme-${themeDisplay}`}>
          <div className="flex border-b pb-2 text-xs flex-col gap-1">
            <div className="flex  gap-3 items-center">
              <PersonIcon sx={{ width: "15px" }} className="text-main" />
              <span>
                {" "}
                {userDetails?.chFirstName} {userDetails?.chLastName} (
                {userDetails?.chUserTypeTitle})
              </span>
            </div>

            <div className="flex gap-3 items-center">
              <PhoneIphoneIcon sx={{ width: "15px" }} className="text-main" />
              <span> {userDetails?.chMobile} </span>
            </div>
          </div>
          <Link to={"/setting"}>
            <div className="flex gap-3 items-center">
              <SettingsIcon sx={{ width: "15px" }} className="text-main" />
              <span className="text-xs"> تنظیمات سایت </span>
            </div>
          </Link>
          <div
            onClick={handleLogout}
            className="flex gap-3 items-center cursor-pointer text-red-700"
          >
            <LogoutIcon sx={{ width: "15px" }} />
            <span className="text-xs">خروج </span>
          </div>
        </div>
      </Popover>
      <Modal
        open={newVersion}
        onClose={() => {
          setNewVersion(false);
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { md: "90%", xs: "90%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
            overflow: "auto",
            maxHeight: "95%",
            maxWidth: "400px",
          }}
        >
          <div className="border-b border-solid pb-4">
            <h2 className="text-sm font-bold">
              ورژن جدیدی از برنامه در درسترس است{" "}
            </h2>
          </div>
          <div className="flex col-span-2 justify-between items-center mt-5">
            <Button
              onClick={handleUpdate}
              sx={{ width: "8rem" }}
              variant="contained"
              color="primary"
            >
              <> بروزرسانی</>
            </Button>{" "}
            <Button
              onClick={() => {
                setNewVersion(false);
              }}
              sx={{ width: "8rem", background: "#ccc" }}
              variant="contained"
              color="inherit"
            >
              انصرف
            </Button>
          </div>
        </Box>
      </Modal>
    </Box>
  );
};

export default PageTitle;
